'use client'

import Heading from '@shared/components/Heading/Heading'
import Page from '@/components/Page/Page'
import Pill from '@shared/components/Pill/Pill'
import Text from '@shared/components/Text/Text'
import { Stack } from '@christiankaindl/lyts'
import Link from 'next/link'
import { getMetadata } from '@/components/Page/getMetadata'
import { useEffect } from 'react'
import { sendSlackMessageFrontendError } from '@shared/lib/sendSlackMessage'
import { isDev } from '@shared/lib/utils'
import { appName } from '@shared/lib/jurisdiction'
import { usePathname } from 'next/navigation'

export const metadata = getMetadata(
  {
    title: '500 - Ein Fehler ist aufgetreten',
  },
  '',
)

export default function Error({
  error,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const pathname = usePathname()

  useEffect(() => {
    console.log(
      'sending slack message to channel...',
      process.env.NEXT_PUBLIC_VERCEL_ENV,
    )
    if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'development') return

    const url = window.location.href
    const userAgent = navigator.userAgent
    const referrer = document.referrer || '(direct)'
    const deploymentId = process.env.NEXT_PUBLIC_VERCEL_DEPLOYMENT_ID ?? 'unknown'

    sendSlackMessageFrontendError(
      [
        `${isDev ? '[DEV] ' : ''}*Error:* ${error.message}`,
        `*Path:* ${pathname}`,
        `*URL:* ${url}`,
        `*Referrer:* ${referrer}`,
        `*Digest:* ${error.digest ?? 'undefined'}`,
        `*Deployment:* ${deploymentId}`,
        `*UA:* ${userAgent}`,
        '',
        `\`\`\`${error.stack as string}\`\`\``,
      ].join('\n'),
    ).catch((error) => {
      console.error('Failed to send message:', error)
    })
  }, [error, pathname])

  return (
    <Page footer={false}>
      <Stack
        xAlign='center'
        yAlign='center'
        style={{ padding: 21, minHeight: '80vh' }}
      >
        <Heading h={1}>
          Ein Fehler ist aufgetreten{' '}
          <Pill style={{ fontWeight: 400, fontFamily: 'var(--inter-font)' }}>
            500
          </Pill>
        </Heading>

        <Text color='secondary' align='center'>
          Das {appName}-Team wurde informiert.
          <br />
          Falls dieser Fehler öfter auftritt,{' '}
          <Link href='/kontakt'>kontaktiere uns</Link>
        </Text>
      </Stack>
    </Page>
  )
}
